import { EmailNode } from '@react-email/editor/core';
import { mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { LiquidVariablePill } from '../components/LiquidVariablePill';
import { getVariableInfo, getVariableToken } from '../utils/emailVariableCatalog';
import { LIQUID_VARIABLE_NODE } from './liquidVariableNodes';

const DATA_ATTRIBUTE = 'data-liquid-variable';

export const LiquidVariable = EmailNode.create({
	name: LIQUID_VARIABLE_NODE,
	group: 'inline',
	inline: true,
	atom: true,
	selectable: true,
	draggable: false,

	addAttributes() {
		return {
			name: {
				default: '',
				parseHTML: (element) => element.getAttribute(DATA_ATTRIBUTE) ?? '',
				renderHTML: (attributes) => ({ [DATA_ATTRIBUTE]: attributes.name as string }),
			},
		};
	},

	parseHTML() {
		return [{ tag: `span[${DATA_ATTRIBUTE}]` }];
	},

	renderHTML({ HTMLAttributes, node }) {
		const name = node.attrs.name as string;
		return [
			'span',
			mergeAttributes(HTMLAttributes, { class: 'liquid-var', title: name }),
			getVariableInfo(name).label,
		];
	},

	renderToReactEmail({ node }) {
		return getVariableToken((node.attrs?.name as string) ?? '');
	},

	addNodeView() {
		return ReactNodeViewRenderer(LiquidVariablePill, { as: 'span' });
	},
});
